/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_AmenityFilterOption_Array_ } from '../models/ControllerResponse_AmenityFilterOption_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_DevelopmentPipeline_ } from '../models/ControllerResponse_DevelopmentPipeline_';
import type { ControllerResponse_MarketAnalyticsSubscriptionAttributes_ } from '../models/ControllerResponse_MarketAnalyticsSubscriptionAttributes_';
import type { ControllerResponse_MarketAnalyticsSubscriptionAttributes_Array_ } from '../models/ControllerResponse_MarketAnalyticsSubscriptionAttributes_Array_';
import type { ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_ } from '../models/ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_';
import type { ControllerResponse_PropertyOverview_Array_ } from '../models/ControllerResponse_PropertyOverview_Array_';
import type { ControllerResponse_PropertyPOI_Array_ } from '../models/ControllerResponse_PropertyPOI_Array_';
import type { ControllerResponse_RentProjections_ } from '../models/ControllerResponse_RentProjections_';
import type { ControllerResponse_RentScatterPlot_Array_ } from '../models/ControllerResponse_RentScatterPlot_Array_';
import type { ControllerResponse_RentTrends_Array_ } from '../models/ControllerResponse_RentTrends_Array_';
import type { ControllerResponse_SupplyTrends_Array_ } from '../models/ControllerResponse_SupplyTrends_Array_';
import type { ControllerResponse_UnitTypeDetails_Array_ } from '../models/ControllerResponse_UnitTypeDetails_Array_';
import type { ControllerResponse_UnitTypeFilterOption_Array_ } from '../models/ControllerResponse_UnitTypeFilterOption_Array_';
import type { MarketAnalyticsSubscriptionAttributes } from '../models/MarketAnalyticsSubscriptionAttributes';
import type { MarketFilters } from '../models/MarketFilters';
import type { RentProjectionFrequency } from '../models/RentProjectionFrequency';
import type { RentTrendsFrequency } from '../models/RentTrendsFrequency';
import type { RentTrendsMetric } from '../models/RentTrendsMetric';
import type { ScatterPlotMetric } from '../models/ScatterPlotMetric';
import type { SupplyTrendsGrouping } from '../models/SupplyTrendsGrouping';
import type { SupplyTrendsMetric } from '../models/SupplyTrendsMetric';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MarketAnalyticsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/market_analytics/list',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: MarketAnalyticsSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public get(
        id?: number,
    ): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/market_analytics',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public update(
        requestBody: MarketAnalyticsSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/market_analytics',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public delete(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/market_analytics',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_PropertyPOI_Array_ Ok
     * @throws ApiError
     */
    public propertyCoordinates(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_PropertyPOI_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/properties',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_DevelopmentPipeline_ Ok
     * @throws ApiError
     */
    public developmentProjects(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_DevelopmentPipeline_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/development_projects',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param frequency
     * @param requestBody
     * @returns ControllerResponse_RentProjections_ Ok
     * @throws ApiError
     */
    public rentProjections(
        frequency: RentProjectionFrequency,
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_RentProjections_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/rent_projections',
            query: {
                'frequency': frequency,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_UnitTypeDetails_Array_ Ok
     * @throws ApiError
     */
    public unitTypeDetails(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_UnitTypeDetails_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/unit_type_details',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @param metric
     * @returns ControllerResponse_RentScatterPlot_Array_ Ok
     * @throws ApiError
     */
    public rentScatterPlot(
        requestBody: MarketFilters,
        metric?: ScatterPlotMetric,
    ): CancelablePromise<ControllerResponse_RentScatterPlot_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/rent_scatter_plot',
            query: {
                'metric': metric,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @param metric
     * @param frequency
     * @returns ControllerResponse_RentTrends_Array_ Ok
     * @throws ApiError
     */
    public rentTrends(
        requestBody: MarketFilters,
        metric?: RentTrendsMetric,
        frequency?: RentTrendsFrequency,
    ): CancelablePromise<ControllerResponse_RentTrends_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/rent_trends',
            query: {
                'metric': metric,
                'frequency': frequency,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @param metric
     * @param grouping
     * @returns ControllerResponse_SupplyTrends_Array_ Ok
     * @throws ApiError
     */
    public supplyTrends(
        requestBody: MarketFilters,
        metric?: SupplyTrendsMetric,
        grouping?: SupplyTrendsGrouping,
    ): CancelablePromise<ControllerResponse_SupplyTrends_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/supply_trends',
            query: {
                'metric': metric,
                'grouping': grouping,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_PropertyOverview_Array_ Ok
     * @throws ApiError
     */
    public propertyList(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_PropertyOverview_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/property_details',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_AmenityFilterOption_Array_ Ok
     * @throws ApiError
     */
    public amenityFilterOptions(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_AmenityFilterOption_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/amenity_filter_options',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_UnitTypeFilterOption_Array_ Ok
     * @throws ApiError
     */
    public unitTypeFilterOptions(
        requestBody: MarketFilters,
    ): CancelablePromise<ControllerResponse_UnitTypeFilterOption_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market_analytics/analytics/unit_type_filter_options',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
